import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dynamicUrl } from './Function';
import { Row,Col,Card,Placeholder, Button,Tabs,Tab } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const Research = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Pages,setPages]=useState([]);
    useEffect(()=>
    {
        const researchPages = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL + "menu/subMenu/6");
                const result = await response.json();        
                if (result.length > 0) {
                    Promise.all(
                        result.map(e => {
                            // Fetch the submenu
                            const fetchSubmenu = fetch(global.config.API_URL + "menu/subMenu/" + e.sp_id)
                                .then(submenu => submenu.json());
        
                            return fetchSubmenu.then(async submenu => {
                                // For each submenu item, fetch its spImage and spImageHi
                                const submenuWithImages = await Promise.all(
                                    submenu.map(async (submenuItem) => {
                                        const fetchSubImage = fetch(global.config.API_URL + "upload/details/0/" + submenuItem.sp_id + "/spImage")
                                            .then(upp => upp.json());
                                        const fetchSubImageHi = fetch(global.config.API_URL + "upload/details/0/" + submenuItem.sp_id + "/spImageHi")
                                            .then(upph => upph.json());
        
                                        const [subImage, subImageHi] = await Promise.all([fetchSubImage, fetchSubImageHi]);
        
                                        return {
                                            ...submenuItem,
                                            spImage: (subImage.length > 0) ? global.config.uploadPath + subImage[0].up_fname + subImage[0].up_ext : '',
                                            spImageHi: (subImageHi.length > 0) ? global.config.uploadPath + subImageHi[0].up_fname + subImageHi[0].up_ext : ''
                                        };
                                    })
                                );
        
                                // Return the main item with its submenu populated with images
                                return {
                                    ...e,
                                    submenu: submenuWithImages
                                };
                            });
                        })
                    ).then(allResponse => {
                        allResponse.forEach((el, i) => 
                        {
                            result[i].submenu = el.submenu;
                        });
                        setPages(result);
                    }).catch(error => {
                        console.error('Research Image :', error);                        
                    });
                }        
                if (global.config.IsPrint === true) { console.info('Research Pages : Result', result);
                }
            } catch (error) 
            {
                console.error('Research Pages : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };        
        researchPages();    
    },[])
    const SubPage = ({submenu}) =>
    {
        return (
            <Row className="g-3">
            {submenu.map((sp, index)=>(
                <Col md={3} key={index}>
                    <Card className='text-center bg-dark text-white h-100 shadow' data-aos="flip-up" data-aos-duration="1500">
                        {appLanguage === 'hi' ? 
                            (
                                sp.spImageHi 
                                ? <Card.Img src={sp.spImageHi} /> 
                                : sp.spImage 
                                    ? <Card.Img src={sp.spImage} /> 
                                    : <Placeholder xs={12} style={{minHeight:"180px"}} />
                            ) : (
                                sp.spImage 
                                ? <Card.Img src={sp.spImage} />
                                : <Placeholder xs={12} style={{minHeight:"180px"}} />
                            )
                        }
                        <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center'>
                            <Card.Title style={{minHeight:"50px"}}>
                                {appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name}
                            </Card.Title>
                            <NavLink to={dynamicUrl(sp)} className='btn btn-info rounded'>
                                {t('ReadMore')}
                            </NavLink>
                        </Card.ImgOverlay>
                    </Card>
                </Col>
            ))}
            </Row>
        );
    }
    return (
        <React.Fragment>
        {isLoading ? (
        <Tabs defaultActiveKey="0" className="my-3" fill>
        {[...Array(2)].map((_, index)=>(
            <Tab key={index} eventKey={index} title={<Placeholder xs={10} />}>
                <Row className="g-3">
                {[...Array(8)].map((_, index)=>(
                    <Col md={3} key={index}>
                        <Card className='text-center bg-dark text-white h-100 shadow' data-aos="flip-up" data-aos-duration="1500">
                            <Placeholder xs={12} style={{minHeight:"180px"}} />
                            <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center'>
                                <Card.Title style={{width:"100%",minHeight:"50px"}}>
                                    <Placeholder xs={12} bg="light" />
                                    <Placeholder xs={9} bg="light" />
                                </Card.Title>
                                <Button className='btn btn-info rounded w-25'>
                                    <Placeholder xs={12} />
                                </Button>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                ))}
                </Row>
            </Tab>
        ))}
        </Tabs>
        ) : (
        <Tabs defaultActiveKey="0" className="my-3" fill>
        {Pages.map((sp, index)=>(
            <Tab key={index} eventKey={index} title={appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name}>
                <SubPage submenu={sp.submenu} />
            </Tab>
        ))}
        </Tabs>
        )}
        </React.Fragment>
    );    
}
export default Research;